import type { PlacePhoto } from '../types/place'

const webpByFile = import.meta.glob('../../arboretum-wojslawice/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>

function urlForFile(file: string): string | null {
  const entry = Object.entries(webpByFile).find(([key]) => key.replace(/\\/g, '/').endsWith(`/${file}`))
  return entry?.[1] ?? null
}

const PHOTOS: { file: string; alt: string }[] = [
  {
    file: 'arboretum-wojslawice-glowne-wiosna-z-powietrza.webp',
    alt: 'Arboretum Wojsławice z lotu ptaka wiosną – widok na alejki, zieleń i „Serce Ogrodu”',
  },
  {
    file: 'arboretum-wojslawice-rododendrony-wiosna.webp',
    alt: 'Kwitnące rododendrony wiosną w narodowej kolekcji Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-rosliny-kolekcja.webp',
    alt: 'Kolekcja roślin i rabaty w Arboretum Wojsławice koło Niemczy',
  },
  {
    file: 'arboretum-wojslawice-widok-ogrod.webp',
    alt: 'Spacer po alejkach ogrodu botanicznego Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojlawice-widok-na-gory.webp',
    alt: 'Widok na okoliczne wzgórza z terenu Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-park.webp',
    alt: 'Zielony park i alejki dendrologiczne w Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-alejka-zachod-slonca.webp',
    alt: 'Alejka między drzewami o zachodzie słońca w Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-drzewo-zachod-slonca.webp',
    alt: 'Okazałe drzewo o zachodzie słońca w Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-staw-folwarczny.webp',
    alt: 'Staw folwarczny otoczony zielenią w Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-folwark.webp',
    alt: 'Folwarczny zakątek i zabudowa w Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-budynek.webp',
    alt: 'Zabytkowa zabudowa przy folwarku w Arboretum Wojsławice',
  },
  {
    file: 'arboretum-wojslawice-parking.webp',
    alt: 'Parking dla zwiedzających przy wejściu do Arboretum Wojsławice',
  },
]

function photosFromEntries(entries: { file: string; alt: string }[]): PlacePhoto[] {
  return entries.flatMap((p) => {
    const src = urlForFile(p.file)
    if (!src) return []
    return [{ src, alt: p.alt }]
  })
}

export const arboretumWojslawicePhotos: PlacePhoto[] = photosFromEntries(PHOTOS)

/** Obraz wyróżniający artykułu i meta OG (widok z lotu ptaka, wiosna). */
export const arboretumWojslawiceFeaturedPhoto: PlacePhoto | undefined = arboretumWojslawicePhotos[0]

/** Galeria na końcu artykułu — m.in. nowe zdjęcia numerowane. */
const GALLERY_PHOTOS: { file: string; alt: string }[] = [
  {
    file: 'arboretum-wojlawice (5).webp',
    alt: 'Arboretum Wojsławice – widok na zieleń i alejki w ogrodzie botanicznym',
  },
  {
    file: 'arboretum-wojlawice (10).webp',
    alt: 'Arboretum Wojsławice – rabaty i roślinność w ogrodzie dendrologicznym',
  },
  {
    file: 'arboretum-wojlawice (11).webp',
    alt: 'Arboretum Wojsławice – zakątek ogrodu z drzewami i bylinami',
  },
  {
    file: 'arboretum-wojlawice (12).webp',
    alt: 'Arboretum Wojsławice – spacer między kolekcjami roślin',
  },
  {
    file: 'arboretum-wojlawice (13).webp',
    alt: 'Arboretum Wojsławice – widok na teren ogrodu botanicznego',
  },
  {
    file: 'arboretum-wojlawice (14).webp',
    alt: 'Arboretum Wojsławice – zieleń i kompozycje roślinne na Wzgórzach Niemczańskich',
  },
  {
    file: 'arboretum-wojlawice (15).webp',
    alt: 'Arboretum Wojsławice – kolejny widok ogrodu botanicznego koło Niemczy',
  },
]

export const arboretumWojslawiceGalleryPhotos: PlacePhoto[] = photosFromEntries(GALLERY_PHOTOS)
